import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class PositionForm extends Component {
    constructor(props) {
        super(props);
        var positionGroup = {
            positionGroupId: this.props.dataItem.PositionGroupId ? this.props.dataItem.PositionGroupId: 0,
            description: this.props.dataItem.PositionGroup ? this.props.dataItem.PositionGroup : "",
        }
        var data = {
            positionId: this.props.dataItem.PositionId || 0,
            ranking: Number(this.props.dataItem.Ranking) || 0,
            name: this.props.dataItem.Description || "",
            positionGroupId: this.props.dataItem.PositionGroupId || "",
            isActive: this.props.dataItem.isActive || false,
            positionGroup: positionGroup
        };
		this.state = {
			positionInEdit: data || null,
            value: [],
            originalName: data.name || "",
            originalRank: data.ranking || "",
            originalGroupId: data.positionGroupId,
            PositionMessage: "",
            RankingMessage: "",
            groupMessage: Object.keys(this.props.dataItem).length == 0 ? "Position group required":""
		};
	}

    handleSubmit = (event) => {
        event.preventDefault();

        axios
            .post(`${ROOT_API_URL}/ManagePosition/IsPoisitionAlreadyInGroup`, this.state.positionInEdit, { headers: auth.authHeader() })
            .then((response1) => {           
                axios
                    .post(`${ROOT_API_URL}/ManagePosition/IsRankAlreadyInGroup`, this.state.positionInEdit, { headers: auth.authHeader() })
                    .then((response2) => {
                        let msg1 = "";
                        let msg2 = "";
                        if (this.state.originalGroupId != this.state.positionInEdit.positionGroupId) {
                            msg1 = response1.data.message;
                            msg2 = response2.data.message;
                        }
                        else {
                            if (this.state.originalName != this.state.positionInEdit.name) {
                                msg1 = response1.data.message;
                            }
                            if (this.state.originalRank != this.state.positionInEdit.ranking) {
                                msg2 = response2.data.message;
                            }
                        }
                        this.setState({
                            PositionMessage: msg1,
                            RankingMessage: msg2
                        });
                        if (this.state.PositionMessage == ""
                            && this.state.RankingMessage == ""
                            && this.state.groupMessage == "") {

                            this.props.save(this.state.positionInEdit);
                            this.props.cancel();
                        }
                    })
                    .catch((response2) => {
                        console.log(response2);
                    });
            })
            .catch((response1) => {
                console.log(response1);
            });
	};
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
	onDialogInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.positionInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
            positionInEdit: edited,
            PositionMessage: ''
		});
    };

    onRankingChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.positionInEdit;
        edited[name] = Number(value);
        edited.isActive = true;
        this.setState({
            positionInEdit: edited,
            RankingMessage: ''
        });
    }
    
    handlePostionGroupChange = (event) => {
        let target = event.target;
        const value = target.value;
        const edited = JSON.parse(JSON.stringify(this.state.positionInEdit));
		edited.positionGroupId = value.positionGroupId;
		edited.positionGroup = value;
		this.setState({
            positionInEdit: edited,
            groupMessage: ""
		});
	}

	render() {
		return (
			<Dialog onClose={this.props.cancel}>
                {!this.state.positionInEdit.positionId ?
                    <h2 className="adjust-dist-title">Add New Position</h2> :
                    <h2 className="adjust-dist-title">Edit Position</h2>}
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="name">Position Name</label>
						<Input
							required={true}
							type="text"
							name="name"
							id="name"
							value={this.state.positionInEdit.name || ''}
							onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.PositionMessage}</p>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="ranking">Ranking</label>
						<Input
                            type="number"
                            min="0"
							name="ranking"
							id="ranking"
							value={this.state.positionInEdit.ranking || ''}
                            onChange={this.onRankingChange}
                        />
                        <p className="error-message">{this.state.RankingMessage}</p>
                    </div>                  
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="positionGroup">Position Group</label>
						<DropDownList  
							required={true}
							data={this.props.positionGroups}
							onChange={this.handlePostionGroupChange}
							value={this.state.positionInEdit.positionGroup}
							textField="description"
							dataItemKey="positionGroupId"
							allowCustom={true}
							name="positionGroup"
							id="positionGroup"
                        />
                        <p className="error-message">{this.state.groupMessage}</p>
					</div>

					<DialogActionsBar>
                        <div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.positionInEdit.positionId ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</Dialog>
		);
	}
}

export default PositionForm;
